import { Typography } from "@mui/material";
import React from "react";
import AppBackdrop from "../appBackdrop/AppBackdrop";
import styles from "./ModalLayout.module.css";
import close_icon from "assets/images/close_icon.svg";

function ModalLayout({
  height,
  title,
  icon,
  handleClose,
  width,
  children,
  openModal,
}) {
  return (
    <AppBackdrop openModal={openModal}>
      <div
        style={{
          height: height,
          width: width,
        }}
        className={styles.modal_layout}
      >
        <div className={styles.heading}>
          <Typography>{title}</Typography>
          <div className={styles.heading_right}>
            {icon && (
              <div className={styles.heading_icon}>
                <img src={icon} alt="" />
              </div>
            )}

            <div
              onClick={() => {
                handleClose();
              }}
              className={styles.close}
            >
              <img src={close_icon} alt="" />
            </div>
          </div>
        </div>
        <div className={styles.body}>{children}</div>
      </div>
    </AppBackdrop>
  );
}

export default ModalLayout;
